import React, { useEffect, useState, useRef } from 'react';
import './login.css';
import Logo from '../../assets/images/circle-logo.svg';
import Leaf from '../../assets/images/leaf.png';
import { loginApi } from '../../utils/api';
import { Toast } from 'primereact/toast';
import Form from 'react-bootstrap/Form';
import Loadr from '../loader/loader'
import { Tooltip } from 'primereact/tooltip';
import Eye from '../../assets/icons/eye.svg'
import HideEye from '../../assets/icons/close-eye.svg'
import useToastNotification from '../../hooks/useToastNotification';

function Profile() {
    const toast = useRef(null);
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [validated, setValidated] = useState(false);
    const [loginLoader, setLoginLoader] = useState(false);
    const [typePassword, setTypePassword] = useState('password');
    const { showError, showSuccess } = useToastNotification();

    useEffect(() => {
        const handleResize = () => {
            const height = window.innerHeight;
            document.body.classList.toggle('keyboard-active', window.innerHeight < height);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);









    const login = async (event, pass) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === true) {
            event.stopPropagation();
            let payload = {
                userName: userName,
                password: password
            }
            try {
                setLoginLoader(true)
                let loginRes = await loginApi(payload)
                console.log(loginRes.data)
                if (loginRes.data.isSuccess) {
                    //save customerInfo in localStorage
            
                    showSuccess('ورود شما با موفقیت انجام شد.');
                    window.localStorage.setItem('userInfo', JSON.stringify(loginRes.data.data))
                    setLoginLoader(false)
                    window.location.href = `/home`;

                } else {
                    setLoginLoader(false)
                   
                    showError(loginRes.data.message);
                }
            } catch (error) {
                setLoginLoader(false)
                showError(error.response.data.message);

            }

        }
        setValidated(true);
    }


    const showPassword = () => {
        setTypePassword('text')
      }
      const hidePassword = () => {
        setTypePassword('password')
      }
    
    return (
        <div className='login-content'>
            <Toast ref={toast} />
            <Tooltip target=".Info-login" />

            {/* otp */}
            <div className='login-card'>
                <img src={Leaf} className='Leaf-img-right' alt="" />
                <img src={Leaf} className='Leaf-img-left' alt="" />
                <div className='items'>


                    <img src={Logo} alt="" className='mx-auto'/>
                    <h5 className='mt-4'>ورود به بک آفیس سایت</h5>

                    <h6 className='mt-4'>لطفا رمز ورود خود را وارد کنید .</h6>
                    <Form noValidate validated={validated} onSubmit={(e) => { login(e) }} className="mt-3">
                        <Form.Group  >
                            <Form.Label style={{ fontWeight: '600' }}>نام کاربری</Form.Label>
                            <Form.Control type="text" required value={userName} onChange={(e) => setUserName(e.target.value)}  />
                        </Form.Group>
                        <Form.Group  className='mt-3'>
                            <Form.Label style={{ fontWeight: '600' }}>رمزعبور</Form.Label>
                            <div className='input-icon'>
                                <Form.Control type={typePassword} required value={password} onChange={(e) => setPassword(e.target.value)}
                                    onKeyDown={(e) => {

                                        if (e.key === 'Enter') {
                                            e.preventDefault(); // Prevent form submission
                                            login(e); // Call login function
                                        }
                                    }} />
                                {typePassword === 'password' ? <img src={Eye} alt="" onClick={showPassword} /> : <img src={HideEye} alt="" onClick={hidePassword} />}
                            </div>
                        </Form.Group>
                        <button type='submit' disabled={loginLoader} className='btn btn-primary mt-4 w-100 d-flex align-items-center justify-content-center gap-2'>ادامه{loginLoader && <Loadr />}</button>

                    </Form>
                </div>
            </div>
        </div>
    );
}

export default Profile;
